import React from 'react';

const TabControl = props => {
    const { children, value, index } = props;

    return <div>{value === index && children}</div>;
};

export default TabControl;
